<template>
  <div>
    <div class="base-container1">
      <div class="title">基础信息</div>
      <ul>
        <li><p>员工数量</p><span>{{ overviewMain.accountCount }}</span></li>
        <li><p>车辆数量</p><span>{{ overviewMain.vehicleCount }}</span></li>
        <li><p>累计订单</p><span>{{ overviewMain.orderMonthCount }}</span></li>
      </ul>
    </div>
    <div class="base-container2">
      <div class="title">待处理事务</div>
      <ul>
        <li @click="onGoInvite"><p>员工申请待审核<i class="icon-left" /></p><span>{{ overviewMain.accountAskCount || 0 }}</span></li>
        <li @click="onGoOrder"><p>今日订单数<i class="icon-left" /></p><span>{{ overviewMain.orderDayCount || 0 }}</span></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { defineComponent, onMounted, reactive, ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import router from '@/router';
import { createApiUrl } from '@/utils/utils';
import { request } from '@/utils/request';
import { assignWithDefault } from '@/utils/illuminate';


const store = useStore();

const defaultOM = {
  accountAskCount: 0,
  accountCount: 0,
  orderDayCount: 0,
  orderMonthCount: 0,
  vehicleCount: 0,
};

const overviewMain = reactive({
  ...defaultOM,
});

const loadOverviewMain = async () => {
  let res;
  try {
    res = await request.get(createApiUrl('/newlinkSass/enterprise/home-page'));
  } catch (e) {
    return message.error(e.message);
  }

  assignWithDefault(overviewMain, res.data, defaultOM);
};

const onGoInvite = () => {
  router.push({ name: 'main.staff.invite_review' });
};
const onGoOrder = () => {
  router.push({ name: 'order.oil' });
};
watch(() => store.state.User.enterprise, val => {
  (val && val.enterpriseId) && loadOverviewMain();
});

onMounted(() => {
  loadOverviewMain();
});
</script>

<style lang="scss" scoped>
.base-container2 {
  margin-top: 16px;

  p {
    cursor: pointer;
  }
}

.base-container1,
.base-container2 {
  height: 184px;
  border-radius: 16px;
  background: #fff;
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .title {
    color: #1d2129;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px; /* 160% */
    margin-bottom: 16px;
  }

  ul {
    flex: 1;
    display: flex;
    justify-content: space-between;

    li {
      flex: 1;
      width: 33%;
      border-radius: 12px;
      background: #f6f9ff;
      margin-right: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &:last-child {
        margin-right: 0;
      }

      p {
        color: #86909c;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 8px;

        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/base-left.png) no-repeat center center;
          background-size: 100%;
          position: relative;
          top: 3px;
        }
      }

      span {
        color: #1d2129;
        font-size: 28px;
        font-weight: 700;
        line-height: 32px;
      }
    }
  }
}
</style>
